/** Quiet period before a location-management sensor edit is persisted. */
export const SENSOR_AUTO_SAVE_DELAY_MS = 800;

export type SensorAutoSaveStatus = "idle" | "pending" | "saved" | "saving";

export const isSensorEditHotkeyBlocked = (event: KeyboardEvent): boolean => {
	if (event.defaultPrevented || event.isComposing) return true;
	if (event.metaKey || event.ctrlKey || event.altKey) return true;
	return Boolean(document.querySelector('[role="listbox"]'));
};

export const isSensorEditEnterTarget = (event: KeyboardEvent): boolean => {
	const target = event.target;
	if (!(target instanceof HTMLElement)) return true;

	return Boolean(
		target.closest('button, [role="button"], [role="combobox"], textarea'),
	);
};
